import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import { formatListItemValues } from '../../../../../../../features/formatters'
import { renderMetricValue } from '../../../../../../../features/components/AdCardListItem/AdCardMetrics/AdCardMetric/renderMetricValue'

import AdCardMetrics from '../../../../../../../features/components/AdCardListItem/AdCardMetrics'
import AdCardMetric from '../../../../../../../features/components/AdCardListItem/AdCardMetrics/AdCardMetric'

function OnsiteAdCardMetrics({ metrics }) {
  const { t } = useTranslation()

  const formattedData = useMemo(() => formatListItemValues(metrics), [metrics])

  const { impressions, clicks } = formattedData

  return (
    <AdCardMetrics>
      <AdCardMetric>
        <div>{t('Impressions')}</div>
        <div>{renderMetricValue(impressions)}</div>
      </AdCardMetric>
      <AdCardMetric>
        <div>{t('Clicks')}</div>
        <div>{renderMetricValue(clicks)}</div>
      </AdCardMetric>
    </AdCardMetrics>
  )
}

export default OnsiteAdCardMetrics

OnsiteAdCardMetrics.propTypes = {
  metrics: PropTypes.shape({
    clicks: PropTypes.number,
    impressions: PropTypes.number
  })
}
